import { makeAutoObservable } from "mobx";
import { User } from "../Model/user";
import { Gamer } from "../Model/gamer";
import axios from "axios";

class GamersStore {
  gamers: Gamer[] = [];
  filter: string = "";

  constructor() {
    makeAutoObservable(this);
    this.loadAll();
  }

  private loadAll() {
    axios
      .get(`https://wallof-backend.uc.r.appspot.com/getprofiles`)
      .then((res) => {
        try {
          // this.gamers = res.data as Gamer[];
          var gamers = res.data as unknown as any;
          if (gamers) {
            gamers = gamers["company"] as Gamer[];
          }
          this.gamers = gamers;
        } catch (e) {
          console.log(e);
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }

  private loadResults() {
    axios
      .post(`https://wallof-backend.uc.r.appspot.com/`)
      .then((res) => {})
      .catch((e) => {});
  }
}

export const gamersStore = new GamersStore();
